<!--
 * @Description: 新增开票类目
 * @Date: 2025-09-12 17:56:29
-->
<template>
  <BaseDialog
    width="650px"
    title="新增类目"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :show-footer="false"
  >
    <BaseTextContent>
      <BaseForm ref="formRef" label-position="right" :model="formData">
        <BaseFormItem
          label="一级类目"
          prop="id"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
        >
          <BaseSelect
            placeholder="请选择"
            v-model="formData.id"
            :filterUseRemote="true"
            :init="true"
            :remoteMethod="val => getInvoiceItemRemoteMethod(val, 1)"
            @change="onInvoiceItemChange"
          />
        </BaseFormItem>
        <BaseFormItem
          label="二级类目"
          prop="subItemId"
          :rules="[
            {
              required: true,
              trigger: 'change',
              message: '请选择'
            }
          ]"
        >
          <BaseSelect
            placeholder="请选择"
            labelKey="name"
            valueKey="id"
            :disabled="!formData.id"
            :filterUseRemote="true"
            :init="false"
            :remoteMethod="val => getInvoiceItemRemoteMethod(val, 2)"
            v-model="formData.subItemId"
            @change="onSubItemChange"
          ></BaseSelect>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="onCancel">取消</BaseButton>
      <BaseButton
        type="primary"
        :disabled="!formData.id || !formData.subItemId"
        :click="onConfirm"
      >
        保存
      </BaseButton>
    </template>
  </BaseDialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseButton,
  BaseTextContent,
  XrkMessage,
  BaseDialog,
  BaseFormItem,
  BaseSelect
} from 'xrk-components';
import { getInvoiceItem, getInvoiceSubItem } from '../../data-source/apis';
import { GetInvoiceItemDataItem } from '../../data-source/types';

const emits = defineEmits(['success']);
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    invoiceItemIdList: GetInvoiceItemDataItem[];
  }>(),
  {}
);

const selectedIds1 = props.invoiceItemIdList.map(item => item.id);
const selectedIds2 = props.invoiceItemIdList.map(item => item.subItemId);

const invoiceBranch = {
  1: { ajax: getInvoiceItem, selectedIds: selectedIds1 },
  2: { ajax: getInvoiceSubItem, selectedIds: selectedIds2 }
};

const formRef = ref();
const formData = ref<GetInvoiceItemDataItem>({
  id: null,
  code: '',
  topLevelCategory: '',
  subcategory: '',
  label: '',
  value: null,
  disabled: false,
  subItemId: null,
  subItemName: null,
  name: null
});

const getInvoiceItemRemoteMethod = async (val: string, type: 1 | 2) => {
  const resp = await invoiceBranch[type].ajax({
    keyword: val,
    ...(formData.value.id && { itemId: formData.value.id }) // 获取二级数据
  });
  resp.data.forEach(item => {
    // 不可重复添加
    if (invoiceBranch[type].selectedIds.includes(item.id)) {
      item.disabled = true;
    }
  });
  return resp;
};

const onInvoiceItemChange = (val, [option]) => {
  formData.value = option;
};
const onSubItemChange = (val, [option]) => {
  Object.assign(formData.value, {
    subItemId: option.id,
    subItemName: option.name
  });
};
const onCancel = () => {
  props.remove();
};

const onConfirm = async () => {
  XrkMessage.success('操作成功');
  emits('success', formData.value);
  onCancel();
};
</script>
